/**
 * @generated SignedSource<<de43a628de083a703a3befc4aa564a2e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductTile_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_user">;
  readonly " $fragmentType": "BuyerProductTile_user";
};
export type BuyerProductTile_user$key = {
  readonly " $data"?: BuyerProductTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductTile_user",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductBaseTile_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "67ab206bcc0f45d849035b2fdf456129";

export default node;
